import { render, staticRenderFns } from "./miniPartner.vue?vue&type=template&id=19b048fe"
import script from "./miniPartner.vue?vue&type=script&lang=js"
export * from "./miniPartner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports